import { type ActionEvent, Controller } from "@hotwired/stimulus"

import ModalController from "../modal_controller"
import { PAGE_TYPE } from "./packages_controller"

import * as Ga4 from "@/helpers/ga4_helper"

export default class extends Controller {
  static outlets = ["booking-modal", "package-details-modal"]
  declare readonly bookingModalOutlet: ModalController
  declare readonly packageDetailsModalOutlet: ModalController

  static targets = ["bookButton"]
  declare readonly bookButtonTarget: HTMLButtonElement
  declare readonly hasBookButtonTarget: boolean

  static values = { ecommerceItems: Array }
  declare readonly ecommerceItemsValue: Ga4.EcommerceItem[]

  bookButtonClick(): void {
    if (this.hasBookButtonTarget) {
      this.bookButtonTarget.click()
    }
  }

  bookPackage({ params: { ecommerceItem, index } }: ActionEvent): void {
    this.bookingModalOutlet.open()
    Ga4.selectItemEvent({ ...ecommerceItem, index }, "booking", PAGE_TYPE)
  }

  buyPackageVoucher({ params: { ecommerceItem, index } }: ActionEvent): void {
    const item = {
      ...ecommerceItem,
      index,
      quantity: 1
    }

    Ga4.selectItemEvent(item, "voucher", PAGE_TYPE)
    Ga4.addToCartEvent(item, ecommerceItem.price)
  }

  viewPackageDetails({ params: { ecommerceItem, index } }: ActionEvent): void {
    this.packageDetailsModalOutlet.open()
    Ga4.viewItemEvent({ ...ecommerceItem, index })
  }
}
